// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"52b44ca0","430":"1a35e949","472":"52b44ca0","524":"f230fe34","558":"75946cc3","818":"2cf7b967"}[chunkId] + ".chunk.css";
};